import React from "react";
import { VStack, Box, Flex, Text, Icon } from "@chakra-ui/react";
import { NavLink, useNavigate } from "react-router-dom";
import { 
  BiLogOut, 
  BiGridAlt, 
  BiTimeFive, 
  BiTransfer, 
  BiCheckDouble, 
  BiHistory, 
  BiCreditCard, 
  BiXCircle, 
  BiBadgeCheck, 
  BiListUl,
  BiWalletAlt 
} from "react-icons/bi";
import { motion } from "framer-motion";
import { useState } from "react";
import LogoutModal from "../Modals/LogoutModal";

const MotionBox = motion(Box);
const MotionFlex = motion(Flex);

const MenuLinks = () => {
  const role = localStorage.getItem("role");
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const navigate = useNavigate();

  const getMenuIcon = (path) => {
    const iconMap = {
      "dashboard": BiGridAlt,
      "instant-loan": BiTimeFive,
      "transactions": BiTransfer,
      "instant-loan-reconcillation": BiCheckDouble,
      "loan-reconcillation": BiHistory,
      "instant-loan-repayment": BiWalletAlt,
      "loan-repayment": BiCreditCard,
      "rejected": BiXCircle,
      "approvals": BiBadgeCheck,
      "verification": BiBadgeCheck,
      "pending-disbursement": BiListUl,
      "direct-debits": BiBadgeCheck
    };
    return iconMap[path] || BiGridAlt;
  };

  const menuLinks = [
    {
      id: 1,
      title: "Main Menu",
      getPages: () => {
        if (role === "Verification") {
          return [{ id: 15, title: "Verification Queue", path: "verification" }];
        }

        const pages = [
          { id: 1, title: "Dashboard", path: "dashboard" },
          { id: 2, title: "Instant Loan", path: "instant-loan" },
          { id: 8, title: "Instant Loan Transactions", path: "transactions" },
          { id: 9, title: "Instant Loan Reconciliation", path: "instant-loan-reconcillation" },
          { id: 10, title: "Loan Reconciliation", path: "loan-reconcillation" },
          { id: 11, title: "Instant Loan Repayments", path: "instant-loan-repayment" },
          { id: 12, title: "Business Loan Repayments", path: "loan-repayment" },
        ];

        if (role === "Reporting") {
          pages.push({ id: 5, title: "Rejected Loans", path: "rejected" });
        }

        if (role === "Admin") {
          pages.push({ id: 3, title: "Approvals", path: "approvals" });
        }

        if (role === "Finance Admin") {
          pages.push(
            { id: 13, title: "Pending Disbursement", path: "pending-disbursement" },
            { id: 14, title: "Direct Debit Mandates", path: "direct-debits" }
          );
        }

        return pages;
      },
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    navigate("/");
  };

  return (
    <Box h="full" display="flex" flexDirection="column">
      <VStack spacing={1} align="stretch" w="full" px="3">
        {menuLinks[0].getPages().map((page) => (
          <NavLink
            to={page.path}
            key={page.id}
            style={{ width: "100%", textDecoration: "none" }}
          >
            {({ isActive }) => (
              <MotionFlex
                p="12px"
                align="center"
                borderRadius="12px"
                cursor="pointer"
                bg={isActive ? "brand.50" : "transparent"}
                color={isActive ? "brand.500" : "gray.500"}
                whileHover={{ x: 5, bg: isActive ? "brand.50" : "gray.50" }}
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 400, damping: 20 }}
                position="relative"
              >
                {isActive && (
                  <MotionBox
                    layoutId="active-nav-indicator"
                    position="absolute"
                    left="0"
                    w="4px"
                    h="20px"
                    bg="brand.500"
                    borderRadius="0 4px 4px 0"
                  />
                )}
                <Icon
                  as={getMenuIcon(page.path)}
                  w={5}
                  h={5}
                  mr="4"
                  color={isActive ? "brand.500" : "gray.400"}
                />
                <Text
                  fontSize="14px"
                  fontWeight={isActive ? "600" : "500"}
                  letterSpacing="0.2px"
                >
                  {page.title}
                </Text>
              </MotionFlex>
            )}
          </NavLink>
        ))}
      </VStack>

      <Box mt="auto" px="3" pb="6">
        <MotionFlex
          p="12px"
          align="center"
          borderRadius="12px"
          cursor="pointer"
          onClick={() => setIsLogoutOpen(true)}
          color="red.500"
          _hover={{ bg: "red.50" }}
          whileHover={{ x: 5 }}
          whileTap={{ scale: 0.98 }}
          transition={{ type: "spring", stiffness: 400, damping: 20 }}
        >
          <Icon as={BiLogOut} w={5} h={5} mr="4" />
          <Text fontSize="14px" fontWeight="600" letterSpacing="0.2px">
            Logout
          </Text>
        </MotionFlex>
      </Box>
      <LogoutModal 
        isOpen={isLogoutOpen} 
        setIsOpen={setIsLogoutOpen} 
        onLogout={handleLogout} 
      />
    </Box>
  );
};

export default MenuLinks;
